import { registerQuery } from 'data-fetching-client';
import { getThemeDetailsPreview } from '../../clients/ecosystemClient';
function getThemeDetailsPreviewData({
  offeringId
}) {
  return getThemeDetailsPreview(offeringId);
}
export const GET_THEME_DETAILS_PREVIEW = registerQuery({
  fieldName: 'detailsPreview',
  args: ['offeringId'],
  fetcher: getThemeDetailsPreviewData
});